// import { Meta, OperationContext } from '../types';
// import { createCloneHandler } from './clone';
// import { createDeleteHandler } from './delete';
// import { createVisibilityHandler } from './visibility';

// export const createOperation = (
//   type: 'clone' | 'delete' | 'visibility',
//   context: OperationContext
// ) => {
//   switch (type) {
//     case 'clone':
//       return createCloneHandler(context);
//     case 'delete':
//       return createDeleteHandler(context);
//     case 'visibility':
//       return createVisibilityHandler(context);
//     default:
//       throw new Error(`Unknown operation type: ${type}`);
//   }
// };
import { OperationContext } from '../types';
import { createCloneHandler } from './clone';
import { createDeleteHandler } from './delete';
import { createVisibilityHandler } from './visibility';
import { OPERATION_TYPES } from '../constants';

export const createOperation = (
  type: keyof typeof OPERATION_TYPES,
  context: OperationContext
) => {
  switch (type) {
    case OPERATION_TYPES.CLONE:
      return createCloneHandler(context);
    case OPERATION_TYPES.DELETE:
      return createDeleteHandler(context);
    case OPERATION_TYPES.VISIBILITY:
      return createVisibilityHandler(context);
    default:
      throw new Error(`Unknown operation type: ${type}`);
  }
};